export default __webpack_public_path__ + "static/media/271.cd26bd71.png";